<template>
  <div class="field">
    <span style="font-size: 10px" class="number">
      {{ label }}
      <caret-up-outlined style="color: crimson" v-if="value1" />
      <caret-down-outlined style="color: limegreen" v-if="!value1" />
    </span>
    <span style="font-size: 10px; color: #999999" class="number">
      {{ value }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'FieldBig1',
  props: {
    label: {
      type: String,
      default: () => undefined,
    },
    value: {
      type: [Number, String],
      default: () => undefined,
    },
    value1: {
      type: Boolean,
      default: () => undefined,
    },
  },
  components: {
    CaretUpOutlined,
    CaretDownOutlined,
  },
});
</script>

<style lang="less" scoped>
@import './index.less';
</style>
